import { createFileRoute } from "@tanstack/react-router";

import { BillingContainer } from "@/features/app-billing/containers/billing-container";

export const Route = createFileRoute("/organisation/billing")({
  component: BillingContainer,
});
